import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import { Payment } from '@/types/Invoice';
import { shortFormatDate } from '@/utils/dates';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { InvoiceSummaryList } from './components/InvoiceSummaryList';
import { InvoiceSummaryListRow } from './components/InvoiceSummaryListRow';

type Props = {
    currency: string;
    payments: Payment[];
    paymentsTotal: number;
};

export const InvoiceSummaryPayments = ({ currency, payments, paymentsTotal }: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <InvoiceSummaryList>
            <H5 className="mb-sm">{formatMessage(['checkout', 'invoice_summary', 'payments_title'])}</H5>
            {payments.map((payment) => {
                return (
                    <div key={payment.ts_now_ts}>
                        <InvoiceSummaryListRow
                            amount={{ amount: payment.amount, currency }}
                            label={shortFormatDate(payment.ts_now_ts)}
                        />
                    </div>
                );
            })}
            {payments.length > 1 && (
                <>
                    <InvoiceSummaryListRow
                        amount={{ amount: paymentsTotal, currency }}
                        bold
                        label={<FormattedMessage id="checkout.totalPaid" />}
                    />
                </>
            )}
        </InvoiceSummaryList>
    );
};
